// Copyright (c) 2022 Siemens

/**
 * @module js/DesCatalogPartListService
 */

/**
 * Get Filter data
 *
 * @param {Object} results results
 * @return {Object} the filter data
 */

export const getSelectedPart = (vmo, selectedPart) => {
    const { data, dispatch } = vmo;

    data.showPartSummary = true;
    data.pathForSelectedPart = selectedPart[0].id;

    dispatch({ path: 'data', value: { ...data } });
}

export const setPartListContentPath = (vmo, selectedFacetFilter) => {
    const { data, dispatch } = vmo;
    if (selectedFacetFilter.eventData) {
        data.featureGroupId = selectedFacetFilter.eventData[0].contentPath
    } else {
        data.featureGroupId = selectedFacetFilter[0].contentPath;
    }
    data.resetAttributes = true;
    data.desTotalCount = 0;
    dispatch({ path: 'data', value: { ...data } });
};

export const setFeatureGroupId = (vmo, props) => {
    const { data, dispatch } = vmo;
    data.featureGroupId = props.contentpath;
    data.desTotalCount = 0;
    dispatch({ path: 'data', value: { ...data } });
};

export const setTimeoutForContentShouldLoadInDOM = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
}
